import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * ChatMessagesList — pure presentational component for the chat conversation.
 * Each message must carry a stable `id` so React reconciliation is correct
 * (avoids array-index-as-key anti-pattern).
 */
export const ChatMessagesList = ({ messages, loading, error }) => (
  <>
    {messages.map((m) => (
      <div
        key={m.id}
        className={`flex ${m.role === 'user' ? 'justify-end' : 'justify-start'}`}
      >
        <div
          className={`max-w-[85%] px-3.5 py-2.5 rounded-2xl text-sm leading-snug whitespace-pre-wrap ${
            m.role === 'user'
              ? 'bg-[#1B2A4A] text-white rounded-br-sm'
              : 'bg-white text-[#0f172a] border border-slate-200 rounded-bl-sm'
          }`}
        >
          {m.content}
        </div>
      </div>
    ))}
    {loading && (
      <div className="flex justify-start">
        <div className="bg-white border border-slate-200 rounded-2xl rounded-bl-sm px-3.5 py-2.5 flex items-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin text-[#1B2A4A]" />
          <span className="text-sm text-slate-500">Pensando...</span>
        </div>
      </div>
    )}
    {error && (
      <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
        {error}
      </div>
    )}
  </>
);

export default ChatMessagesList;
